let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lR2iC")).then(() => parcelRequire('WTx7Y'));